var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTimeshiftEnabled)?_c('i',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(_vm.togglePlay),expression:"togglePlay"}],staticClass:"o-icon",class:_vm.isPaused,attrs:{"aria-label":_vm.$t('accessibility.player.togglePlay')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }